import "./index.scss";
import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import LogoS from "../../assets/images/Logo2024.png";
import LogoSubtitle from "../../assets/images/secODev.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faUser,
  faEnvelope,
  faFile,
  faClose,
} from "@fortawesome/free-solid-svg-icons";
import { faLinkedin, faGithub } from "@fortawesome/free-brands-svg-icons";
import resume from "../../assets/data/CVS.pdf";

const SideBar = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [openNav, setOpenNav] = useState(false);
  useEffect(() => {
    const checkScreenWidth = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkScreenWidth();

    window.addEventListener("resize", checkScreenWidth);

    // Clean up event listener on component unmount
    return () => window.removeEventListener("resize", checkScreenWidth);
  }, []);
  return (
    <div className="nav-bar">
      {isMobile ? (
        <div
          onClick={() => {
            setOpenNav(!openNav);
          }}
          style={{
            width: "100%",
            height: "100%",
          }}
        >
          <Link className="logo">
            {/* <img src={LogoS} alt="logo" /> */}
            <img src={LogoS} alt="logoSub" className="sub-logo" />
          </Link>
        </div>
      ) : (
        <Link className="logo" to="/">
          {/* <img src={LogoS} alt="logo" /> */}
          <img src={LogoS} alt="logoSub" className="sub-logo" />
        </Link>
      )}

      <nav
        style={{
          display: !isMobile || openNav ? "block" : "none",
        }}
      >
        <NavLink
          exact="true"
          activeclassname="active"
          to="/"
          onClick={() => {
            setOpenNav(!openNav);
          }}
        >
          <FontAwesomeIcon icon={faHome} color="#4d4d4e" />
        </NavLink>
        <NavLink
          onClick={() => {
            setOpenNav(!openNav);
          }}
          exact="true"
          activeclassname="active"
          className="about-link"
          to="/about"
        >
          <FontAwesomeIcon icon={faUser} color="#4d4d4e" />
        </NavLink>{" "}
        <NavLink
          onClick={() => {
            setOpenNav(!openNav);
          }}
          exact="true"
          activeclassname="active"
          className="contact-link"
          to="/contact"
        >
          <FontAwesomeIcon icon={faEnvelope} color="#4d4d4e" />
        </NavLink>
      </nav>
      <ul>
        <li>
          <a
            href="https://www.linkedin.com/in/oshri-el-tzagay-873482226/"
            target="_blank"
            rel="noreferrer"
          >
            <FontAwesomeIcon icon={faLinkedin} color="#4d4d4e" />
          </a>
        </li>{" "}
        <li>
          <a
            href="https://github.com/OshriTzagay"
            target="_blank"
            rel="noreferrer"
          >
            <FontAwesomeIcon icon={faGithub} color="#4d4d4e" />
          </a>
        </li>
        <li>
          <a href={resume} download="Oshri-Tzagay.pdf">
            <FontAwesomeIcon icon={faFile} color="#4d4d4e" />
          </a>
        </li>
        {/* <li>
          <a href="" target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faGithub} color="#4d4d4e" />
          </a>
        </li> */}
      </ul>
    </div>
  );
};

export default SideBar;
